import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { TranslationService } from '../../../services/translation.service';
import { ProgressCardComponent } from '../../ui/progress-card/progress-card.component';
import { ToolsRecommendationComponent } from '../../tools/tools-recommendation.component';
import { BandScaleComponent } from '../../ui/band-scale/band-scale.component';
import { ProgressCardVM } from '../../results-vm';
import { BAND_CONFIG } from '../../results-placeholders';
import { ThinkPanelVM, RecallInsight } from './think-vm';

/** paid-3 — THINK™ cognitive signal. */
@Component({
  selector: 'app-think-panel',
  standalone: true,
  imports: [CommonModule, TranslatePipe, ProgressCardComponent, ToolsRecommendationComponent, BandScaleComponent],
  templateUrl: './think-panel.component.html',
})
export class ThinkPanelComponent {
  @Input() vm!: ThinkPanelVM;
  @Output() goPaywall = new EventEmitter<void>();
  @Input() active = false;
  @Input() progress: ProgressCardVM | null = null;

  /** wordfirst sec 2/3 — 3-level bar config for the hero verdict (higher = better). */
  readonly bandConfig = BAND_CONFIG.think;

  constructor(private i18n: TranslationService) {}

  /** Step2 change5: translated {free}/{cued}/{missed} item lists for the recall
   *  cue-benefit sentence. */
  recallParams(insight: RecallInsight): Record<string, string> {
    return {
      free: this.joinItems(insight.free),
      cued: this.joinItems(insight.cued),
      missed: this.joinItems(insight.missed),
    };
  }

  /** Translate the item-field keys (name/color/object/place) into their labels
   *  and join them per language ("בשם, בצבע ובמקום" / "the name, the color and
   *  the place"). */
  private joinItems(keys: string[]): string {
    const labels = (keys || []).map((k) =>
      this.i18n.translate(`results.th.recallItems.${k}`)
    );
    if (labels.length === 0) return '';
    if (labels.length === 1) return labels[0];
    const head = labels.slice(0, -1).join(', ');
    const last = labels[labels.length - 1];
    return this.i18n.getCurrentLanguage() === 'he'
      ? `${head} ו${last}`
      : `${head} and ${last}`;
  }
}
